export default __webpack_public_path__ + "locales/ar-SA/Files.json?hash=891991419f47873210a21e65f8972cf2";